import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";

import {map} from "rxjs/operators";

import {AccessService} from "./services/access";
import {DataService} from "./services/data";

export const ClientGuard: CanActivateFn = (route, state) => {

    const accessService = inject(AccessService);
    const dataService = inject(DataService);
    const router = inject(Router);

    return dataService.request("Client/get", {
        domain: window.location.hostname
    }).pipe(
        map((response: any) => {
            if (response.client) {
                accessService.client = response.client;
                return true;
            } else {
                //router.navigate(["/denied"]);
                //window.location.href = "https://www.noteradar.at/";
                return false;
            }
        })
    );
};
